import   React  from 'react';
import   classNames              from 'classnames';

import   styles                  from './Stats.module.scss';

import   Tabs2                   from '../../widget/navigation/Tabs2';

import   LiveStats               from "./LiveStats";
import   ReplayStats             from "./ReplayStats";
import   RedirectionStats        from "./RedirectionStats";

export const Stats = () => {
    
  return (
          <div className = {classNames(styles.root)}>

            <div className = {classNames(styles.contain)}>
              <Tabs2 tabs = {[
                               {
                                  label: 'Live',
                                  children: <LiveStats />,

                               },
                               {
                                  label: 'Replay',
                                  children: <ReplayStats />,

                               },
                               {
                                  label: 'Redirection',
                                  children: <RedirectionStats />,

                               },
							]}
              />
            </div>
          </div>
         );
};

export default Stats;
